module.exports = {
	"careType": null,
	"id": null,
	"name": null,
	"assessmentType": null,
	"riskScore": null,
	"showAssessment": false,
	"sections": {
		"contributingfactors": {},
		"riskindicators": {},
		"riskratings": {
			"label": "B",
			"acute": {},
			"communitycare": {},
			"ems": {},
			"longterm": {},
			"comments": null,
			"description": "Risk specific suggested interventions have been provided. Check off the interventions that will be implemented for this client.  Complete Section C Contributing Factors to identify client specific factors that may trigger or escalate violent, aggressive, or responsive behaviours and ensure the care plan includes measures to avoid or reduce risk behaviours identified.",
			"title": "Risk Rating"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/initialStore/baseStore.json
// module id = 881
// module chunks = 0